import React from 'react'

export const Equivalencies = [
  {
    name: 'list',
    component: React.lazy(() => import('../../../modules/admin/more/equivalencies/EquivalenciesList')),
    path: '/admin/equivalencies',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: 'create',
    component: React.lazy(() => import('../../../modules/admin/more/equivalencies/EquivalenciesCreate')),
    path: '/admin/equivalencies/create',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
]
